/**
 * Error HTTP normalizado. Conserva el mensaje que ya se mostraba (extiende Error)
 * y además expone el status y el código de negocio del backend (p. ej. WST-409,
 * WST-404-RECLASSIFICATION-DISABLED), que antes se perdían.
 */
export class HttpApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code?: string,
    public readonly body?: unknown
  ) {
    super(message);
    this.name = 'HttpApiError';
  }
}
